import { node } from "~/util/dom";

// https://gitlab.seznam.net/mapycz/routeserver-ng/-/blob/master/server/doc/rpc.help?ref_type=heads#L46
const CRITERIONS = {
	111: "auto placena rychla",
	112: "auto neplacena rychla",
	113: "auto placena kratka",
	114: "auto neplacena kratka",
	115: "auto placena v.kratka (nejkratsi)",
	116: "auto neplacena v.kratka (nejkratsi)",
	121: "kolo mtb stare, bude prepsano 129", // vymyslel kokot!
	122: "kolo silnice",
	123: "kolo mtb",
	124: "kolo gravel/trek",
	125: "kolo smooth",
	129: "cykloturista",
	131: "pesi kratka",
	132: "pesi turisticka",
	133: "pesi smooth",
	134: "pesi beh",
	141: "lyze",
	142: "skialpy",
	144: "lod, jezdi jen na vode obema smery",
	145: "prime spojeni dvou bodu vzdusnou carou vytvareni geometrii pro jizdni rady",
	191: "autobus",
	193: "tramvaj",
	194: "metro",
	195: "lanovka",
	196: "trajekt+privoz",
	197: "vlak",
};

export class ModuleRouteDebug {
	_responseData: any;

	_routeState: any;

	_dom: {
		[key: string]: HTMLElement;
	};

	constructor(responseData, routeState) {
		this._dom = {
			container: node("div", { className: `route-module-debug module-content` }),
		};
		this._responseData = responseData;
		this._routeState = routeState;

		this._build();
	}

	destroy() {
		this._dom.container.remove();
	}

	get container() {
		return this._dom.container;
	}

	_build() {
		const params = this._routeState.params;
		const lines: Array<{ text: string; error?: boolean; }> = [];
		const avoidToll = [112, 114].includes(params.criterion);

		if (params.criterion) {
			lines.push({ text: `criterion: <strong>${params.criterion}</strong>` });
			lines.push({ text: `criterion name: <strong>${CRITERIONS[params.criterion]}</strong>` });
		}

		lines.push({ text: `avoidHighways: <strong>${params.avoidHighways ? "ano" : "ne"}</strong>`, error: !params.avoidHighways });
		lines.push({ text: `allowViaFerrata: <strong>${params.allowViaFerrata ? "ano" : "ne"}</strong>`, error: !params.allowViaFerrata });
		lines.push({ text: `avoidToll: <strong>${avoidToll ? "ano" : "ne"}</strong>`, error: !avoidToll });
		lines.push({ text: `useTraffic: <strong>${params.useTraffic ? "ano" : "ne"}</strong>`, error: !params.useTraffic });

		if (params.excludeCountries.length > 0) {
			lines.push({ text: `excludeCountries: <strong>${params.excludeCountries.join(", ")}</strong>` });
		}

		for (const line of lines) {
			this._dom.container.append(node("p", { innerHTML: line.text, className: "error" in line ? line.error ? "line error" : "line" : "" }));
		}
	}
}
